module.exports = __webpack_public_path__ + "img/reg1.4fb85c46.jpg";